import { Link, useLocation } from 'react-router-dom';
import { Search, Menu, X } from 'lucide-react';
import { useState } from 'react';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/encyclopedie', label: 'Encyclopédie' },
    { path: '/guides', label: 'Guides & Articles' },
    { path: '/glossaire', label: 'Glossaire' },
    { path: '/a-propos', label: 'À Propos' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header-container">
      <div className="header-content">
        {/* Logo */}
        <Link to="/" className="logo">
          <div className="logo-icon"></div>
          <span className="logo-text">Savoir des Pierres</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="desktop-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${isActive(link.path) ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Mobile Menu Toggle */}
        <button
          className="mobile-menu-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <nav className="mobile-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`mobile-nav-link ${isActive(link.path) ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      )}

      <style jsx>{`
        .header-container {
          background: rgba(255, 253, 250, 0.95);
          backdrop-filter: blur(10px);
          border-bottom: 1px solid rgba(122, 141, 105, 0.15);
          position: sticky;
          top: 0;
          z-index: 100;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
        }

        .header-content {
          max-width: 1400px;
          margin: 0 auto;
          padding: 1.25rem 2rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .logo {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          text-decoration: none;
          transition: opacity 0.2s ease;
        }

        .logo:hover {
          opacity: 0.8;
          transform: none;
        }

        .logo-icon {
          width: 36px;
          height: 36px;
          background: linear-gradient(135deg, #6b8e6f 0%, #88a589 100%);
          border-radius: 8px;
          position: relative;
        }

        .logo-icon::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 18px;
          height: 18px;
          background: #fffdfabackground: linear-gradient(135deg, #6b8e6f 0%, #556b55 60%, #7a8d69 100%);
          clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
        }

        .logo-text {
          font-family: 'Playfair Display', serif;
          font-size: 1.35rem;
          font-weight: 600;
          color: #3d4a3e;
        }

        .desktop-nav {
          display: flex;
          gap: 2rem;
          align-items: center;
        }

        .nav-link {
          text-decoration: none;
          color: #5a6b5a;
          font-weight: 500;
          font-size: 0.95rem;
          padding: 0.5rem 0;
          position: relative;
          transition: color 0.2s ease;
        }

        .nav-link::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 2px;
          background: #6b8e6f;
          transition: width 0.3s ease;
        }

        .nav-link:hover {
          color: #6b8e6f;
          transform: none;
        }

        .nav-link:hover::after,
        .nav-link.active::after {
          width: 100%;
        }

        .nav-link.active {
          color: #6b8e6f;
          font-weight: 600;
        }

        .mobile-menu-btn {
          display: none;
          background: none;
          border: none;
          color: #6b8e6f;
          cursor: pointer;
          padding: 0.5rem;
        }

        .mobile-nav {
          display: none;
        }

        @media (max-width: 768px) {
          .desktop-nav {
            display: none;
          }

          .mobile-menu-btn {
            display: block;
          }

          .mobile-nav {
            display: flex;
            flex-direction: column;
            padding: 1rem 2rem 1.5rem;
            background: rgba(255, 253, 250, 0.98);
            border-top: 1px solid rgba(122, 141, 105, 0.15);
          }

          .mobile-nav-link {
            padding: 0.875rem 0;
            text-decoration: none;
            color: #5a6b5a;
            font-weight: 500;
            border-bottom: 1px solid rgba(122, 141, 105, 0.08);
            transition: color 0.2s ease, padding-left 0.2s ease;
          }

          .mobile-nav-link:hover,
          .mobile-nav-link.active {
            color: #6b8e6f;
            padding-left: 0.5rem;
          }

          .mobile-nav-link.active {
            font-weight: 600;
          }

          .header-content {
            padding: 1rem 1.5rem;
          }

          .logo-text {
            font-size: 1.15rem;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;